module["exports"] = [
  "Nepal"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/address/default_country.js
// module id = 1534
// module chunks = 1